import React, { useEffect, useState } from "react"
import { Link } from "react-router"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import Rightbar from 'pages/main/wms/transfer/Rightbar'
import DeleteModal from 'pages/parts/DeleteModal'
import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'
import DocumentStatusHistory from 'pages/parts/DocumentStatusHistory'
import PeriodPicker from 'pages/parts/PeriodPicker'

import { httpOk, DELETE, GET } from 'helpers/api'
import { formatDate, returnSign, findKeyFromArrayByValue, formatMoney } from 'helpers/helpers'

function Index() {
	const { t } = useTranslation()
	const date = new Date()

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState({})
	const [statusHistoryId, setStatusHistoryId] = useState(null)
	const [wms, setWms] = useState([])
	const [poses, setPoses] = useState([])
	const [documentStatuses, setDocumentStatuses] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [modalDelete, setModalDelete] = useState(false)
	const [deleteModalParams, setDeleteModalParams] = useState({ id: 0, index: 0 })
	const [showRightBar, setShowRightBar] = useState({ 'document': false })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const initialFilterData = {
		start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		pos_id: reduxAccount.pos_id,
		search: '',
	}
	const initialPagination = { url: '/wms-transfer', response: null }
	const {
		filterData,
		appliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		patchFilterData,
		applySearch,
		applyFilters,
		paginate,
		resetFilters,
	} = useFilterSearchPagination({ initialFilterData, initialPagination })

	async function searchWithFilter(customFilterData = filterData) {
		var filterUrl = "/wms-transfer"
		var urlParams = ""
		checkFilter()

		if (customFilterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + customFilterData.pos_id
		if (customFilterData.from_wms_id)
			urlParams += returnSign(urlParams) + 'from_wms_id=' + customFilterData.from_wms_id
		if (customFilterData.to_wms_id)
			urlParams += returnSign(urlParams) + 'to_wms_id=' + customFilterData.to_wms_id
		if (customFilterData.to_wms_id)
			urlParams += returnSign(urlParams) + 'to_wms_id=' + customFilterData.to_wms_id
		if (customFilterData.document_status)
			urlParams += returnSign(urlParams) + 'document_status=' + customFilterData.document_status
		if (customFilterData.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + customFilterData.start_date
		if (customFilterData.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + customFilterData.end_date
		if (customFilterData.search)
			urlParams += returnSign(urlParams) + 'search=' + customFilterData.search
		if (customFilterData.page)
			urlParams += returnSign(urlParams) + 'page=' + customFilterData.page

		if (`/wms-transfer${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}

		setDropdownIsOpen(false)
	}

	async function deleteItem() {
		const response = await DELETE(`/wms-transfer/${deleteModalParams.id}`, {}, { loader: true })
		if (httpOk(response)) {
			setModalDelete(false)
			searchWithFilter()
		}
	}

	async function toggleRightbar(boolean = false, item) {
		if (boolean) {
			const response = await GET(`/wms-transfer/${item.id}`, {}, { loader: true })
			if (httpOk(response)) {
				setSelectedItem(response.data)
				setShowRightBar({ ...showRightBar, 'document': true })
			}
		} else {
			setSelectedItem({})
			setShowRightBar({ ...showRightBar, 'document': false })
		}
	}

	function resetFilter() {
		resetFilters({
			start_date: formatDate(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd'),
			end_date: formatDate(new Date(), 'yyyy-MM-dd'),
			pos_id: null,
			payment_type_id: null,
			menu_id: null,
			cashier_login: null,
			waiter_login: null,
			search: '',
		}, searchWithFilter)
	}

	function checkFilter() {
		if (
			filterData.pos_id === null &&
			filterData.search === ''
		) {
			// managed by hook when filters are reset
		}
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handlePaginate(page) {
		const nextFilterData = { ...filterData, page }
		paginate(page)
		searchWithFilter(nextFilterData)
	}

	async function getPoses() {
		const response = await GET('/helper/poses')
		if (httpOk(response)) setPoses(response.data)
	}

	async function getWms() {
		var filterPosId = filterData.pos_id ? filterData.pos_id : reduxAccount.pos_id
		const response = await GET(`/helper/wms?pos_id=${filterPosId}`)
		if (httpOk(response)) setWms(response.data)
	}

	async function getDocumentStatuses() {
		const response = await GET('/helper/document-statuses?entity=wms_transfer_wms')
		if (httpOk(response)) setDocumentStatuses(response.data)
	}

	useEffect(() => {
		getPoses()
		getWms()
		getDocumentStatuses()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('transfer_between_wms')} [{data.total}]
				</h4>
				<div className="d-flex">
					<Link className="btn-rounded btn btn-primary" to="/wms-transfer-wms/create">
						{t('create')}
					</Link>
				</div>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex justify-content-between flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									value={filterData.search}
									onSearchChange={(search) => applySearch(search, searchWithFilter)}>
								</FilterSearch>
							</div>
							<div>
								<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
									<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
										{t('filter')}
									</Dropdown.Toggle>

									<Dropdown.Menu className="dropdown-filter">
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('pos')}</label>
												<Select
													options={poses}
													value={poses.find(option => option.id === filterData.pos_id) || ''}
													onChange={(option) => {
														patchFilterData({ 'pos_id': option.id })
														getWms(option.id)
													}}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('from_warehouse')}</label>
												<Select
													isClearable
													options={wms}
													value={wms.find(option => option.id === filterData.from_wms_id) || ''}
													onChange={(option) => patchFilterData({ 'from_wms_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
											<div className="form-group col-md-6">
												<label>{t('to_warehouse')}</label>
												<Select
													isClearable
													options={wms}
													value={wms.find(option => option.id === filterData.to_wms_id) || ''}
													onChange={(option) => patchFilterData({ 'to_wms_id': option ? option.id : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => option.name}
													getOptionValue={(option) => option.id}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-6">
												<label>{t('status')}</label>
												<Select
													isClearable
													options={documentStatuses}
													value={documentStatuses.find(option => option.value === filterData.document_status) || ''}
													onChange={(option) => patchFilterData({ 'document_status': option ? option.value : null })}
													placeholder=""
													noOptionsMessage={() => t('list_empty')}
													getOptionLabel={(option) => t(option.value)}
													getOptionValue={(option) => option.value}
												/>
											</div>
										</div>
										<div className="row">
											<div className="form-group col-md-12">
												<label>{t('period')}</label>
												<PeriodPicker
													startDate={filterData.start_date}
													endDate={filterData.end_date}
													onChange={(period) => patchFilterData(period)}
													withTime={false}
													minDate={new Date(new Date().getFullYear() - 1, 0, 1)}
													maxDate={new Date(new Date().getFullYear(), 11, 31)}
												/>
											</div>
										</div>
										<div className="row mt-3">
											<div className="col-md-12">
												<div className="d-flex justify-content-end">
													<button className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('cancel')}</button>
													<button className="btn btn-primary" onClick={() => applyFilters(searchWithFilter)}>{t('apply')}</button>
												</div>
											</div>
										</div>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						</div>
						<div className="vertical-center">
							<h4><b>{t('amount')}:</b> {formatMoney(data?.total_amount)}</h4>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(appliedFilterData.start_date || appliedFilterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{appliedFilterData.start_date &&
											<span>{formatDate(appliedFilterData.start_date)}</span>
										}
										{(appliedFilterData.start_date && appliedFilterData.end_date) &&
											<span>|</span>
										}
										{appliedFilterData.end_date &&
											<span>{formatDate(appliedFilterData.end_date)}</span>
										}
									</span>
								}
								{appliedFilterData.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', appliedFilterData.pos_id, 'name')}
									</span>
								}
								{filterData.document_status &&
									<span className="me-2">
										<b>{t('status')}: </b>
										{t(filterData.document_status)}
									</span>
								}
								{appliedFilterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{appliedFilterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }}>{t('pos')}</th>
									<th style={{ 'width': '15%' }}>{t('from_warehouse')}</th>
									<th style={{ 'width': '15%' }}>{t('to_warehouse')}</th>
									<th style={{ 'width': '35%' }}>{t('note')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('date')}</th>
									<th style={{ 'width': '10%' }} className="text-end">{t('amount')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className={`text-center ${item.status === -1 ? 'bg-danger text-white' : ''}`}
											title={item.status === -1 ? t('deleted') : ''}>
											{item.row_number}
										</td>
										<td className="td-ellipsis"
											onClick={() => toggleRightbar(true, item)}>
											<span className="text-primary cursor">{item.pos_name}</span>
										</td>
										<td className="td-ellipsis">{item.wms_from_name}</td>
										<td className="td-ellipsis">{item.wms_to_name}</td>
										<td className="td-ellipsis">{item.note}</td>
										<td className="text-center">{formatDate(item.created_at, 'dd.MM.yy HH:mm')}</td>
										<td className="td-ellipsis text-end">{formatMoney(item.total_amount)}</td>
										<td className="d-flex justify-content-center">
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<Link className="table-dropdown-item"
															to={`/wms-transfer-wms/preview/${item.id}`}>
															<i className="uil-eye"></i>
															{t('preview')}
														</Link>
														<div className="table-dropdown-item"
															onClick={() => setStatusHistoryId(item.id)}>
															<i className="uil-history"></i>
															{t('document_status_history')}
														</div>
														{/* Удаление — последним пунктом: промах мимо соседнего пункта дороже всего */}
														{item.status !== -1 &&
															<div className="table-dropdown-item text-danger"
																onClick={() => {
																	setDeleteModalParams({ id: item.id, index: index });
																	setModalDelete(true)
																}}>
																<i className="uil-times"></i>
																{t('delete')}
															</div>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{showRightBar.document &&
				<Rightbar
					showRightBar={showRightBar.document}
					setShowRightBar={setShowRightBar}
					data={selectedItem}>
				</Rightbar>
			}

			<DeleteModal
				modalDelete={modalDelete}
				setModalDelete={setModalDelete}
				deleteItem={deleteItem}>
			</DeleteModal>

			<DocumentStatusHistory
				entity="wms_transfer_wms"
				documentId={statusHistoryId}
				setDocumentId={setStatusHistoryId}>
			</DocumentStatusHistory>
		</>
	)
}

export default Index